import { Component } from '@angular/core';
import { UiDaysBeforeDeliveryComponent } from '../ui-days-before-delivery.component';

@Component({
  standalone: false,
  selector: 'ui-days-left-count',
  templateUrl: './ui-days-left-count.component.html'
})
export class UiDaysLeftCountComponent extends UiDaysBeforeDeliveryComponent {
}
